import { createGalleryLayout } from "./components/_layout";

const page = createGalleryLayout("torenler-ve-kutlamalarimiz", "Törenler ve Kutlamalarımız", 7, false);

export default page;